import { CalendarOff, type LucideIcon, Palmtree, PartyPopper, Pill } from 'lucide-react';

import { TimeOffTypeCode } from '@/modules/common/types/time-off-type';

export const TIME_OFF_TYPE_ICON_MAP: Record<TimeOffTypeCode, LucideIcon> = {
  [TimeOffTypeCode.PAID_VACATION]: Palmtree,
  [TimeOffTypeCode.SICK_LEAVE]: Pill,
  [TimeOffTypeCode.UNPAID_TIME_OFF]: CalendarOff,
  [TimeOffTypeCode.PUBLIC_HOLIDAY]: PartyPopper,
};

const DEFAULT_TIME_OFF_TYPE_ICON: LucideIcon = Palmtree;

export const getTimeOffTypeIcon = (code: TimeOffTypeCode): LucideIcon =>
  TIME_OFF_TYPE_ICON_MAP[code] ?? DEFAULT_TIME_OFF_TYPE_ICON;
